export function isMovingDown(sourceIndex, destinationIndex) {
  return sourceIndex < destinationIndex;
}

export function changeItemPosition(arr, sourceIndex, destinationIndex) {
  const newArr = [...arr];
  const item = newArr[sourceIndex];

  const movingDown = isMovingDown(sourceIndex, destinationIndex);

  newArr.splice(movingDown ? destinationIndex + 1 : destinationIndex, 0, item);
  const removeIndex = movingDown ? sourceIndex : sourceIndex + 1;

  newArr.splice(removeIndex, 1);

  return newArr;
}

export function getItemAbove(arr, sourceIndex, destinationIndex) {
  if (destinationIndex === 0) {
    return null;
  }

  if (isMovingDown(sourceIndex, destinationIndex)) {
    return arr[destinationIndex];
  }

  return arr[destinationIndex - 1];
}

export function getItemBelow(arr, sourceIndex, destinationIndex) {
  if (destinationIndex === arr.length - 1) {
    return null;
  }

  if (isMovingDown(sourceIndex, destinationIndex)) {
    return arr[destinationIndex + 1];
  }

  return arr[destinationIndex];
}



// WEBPACK FOOTER //
// ./src/utils/positioning.js